import TrackElements from '@capsule/track-elements'

export default class ArticleGuides {
	private readonly guidesContainer: HTMLElement | null
	cardsNotVisible: NodeListOf<Element> | []
	private readonly ctaExpand: HTMLElement | null | undefined
	private trackElements: TrackElements | null | undefined
	private readonly ctaText: HTMLElement | null | undefined
	private readonly ctaCollapsedText: string
	private readonly ctaExpandedText: string
	private isExpanded: boolean

	constructor() {
		this.guidesContainer = document.querySelector('.articleGuides')
		this.cardsNotVisible =
			this.guidesContainer?.querySelectorAll(
				'.articleGuides-contentCard[data-is-visible="false"]'
			) ?? []
		this.ctaExpand = this.guidesContainer?.querySelector('.articleGuides-contentCta') || null
		this.ctaText = this.ctaExpand?.querySelector('.cta-text') || null
		this.ctaCollapsedText = this.ctaExpand?.textContent || 'Lire plus'
		this.ctaExpandedText = this.ctaExpand?.getAttribute('data-content-expanded') || 'Lire moins'
		this.isExpanded = false
		this.trackElements = null

		this.handleToggleClick = this.handleToggleClick.bind(this)
	}

	init() {
		// If guide contain less than 3 articles, cta are not displayed
		if (this.ctaExpand) {
			this.addEvent()
		}

		this.addEventTracking()
	}

	addEvent() {
		this.ctaExpand?.addEventListener('click', this.handleToggleClick)
	}

	addEventTracking() {
		const linkHero = document.getElementById('articleGuides-hero')
		const linkHeroTitle = document.getElementById('articleGuides-heroOverlayTitle')
		const linkCta = document.getElementById('articleGuides-heroOverlayCta')

		const articles = this.guidesContainer?.querySelectorAll('.articleGuides-contentCard') ?? []
		const articlesTracking = []

		for (const article of articles) {
			if (!(article instanceof HTMLElement)) continue

			const articleId = article.getAttribute('data-article-index')
			articlesTracking.push({
				element: article,
				click: {
					event: 'navigation_click',
					navigation_type: 'travel-guide',
					navigation_label: 'suivez-le-guide',
					navigation_name: `article-${articleId}`
				}
			})
		}

		this.trackElements = new TrackElements([
			{
				element: this.guidesContainer,
				display: {
					event: 'navigation_display',
					navigation_type: 'travel-guide',
					navigation_label: 'suivez-le-guide'
				}
			},
			{
				element: linkHero,
				click: {
					event: 'navigation_click',
					navigation_type: 'travel-guide',
					navigation_label: 'suivez-le-guide',
					navigation_name: linkHeroTitle?.textContent?.trim() || ''
				}
			},
			{
				element: linkCta,
				click: {
					event: 'navigation_click',
					navigation_type: 'travel-guide',
					navigation_label: 'suivez-le-guide',
					navigation_name: linkCta?.querySelector('.cta-text')?.textContent?.trim() || ''
				}
			},
			...articlesTracking
		])
		this.trackElements.init()
	}

	handleToggleClick() {
		this.isExpanded = !this.isExpanded

		for (const card of this.cardsNotVisible) {
			card.setAttribute('data-is-visible', String(this.isExpanded))
		}

		if (this.ctaExpand && this.ctaText) {
			this.ctaText.textContent = this.isExpanded
				? this.ctaExpandedText
				: this.ctaCollapsedText
			this.ctaExpand?.classList.toggle('isExpanded', this.isExpanded)
			this.ctaExpand?.setAttribute('aria-expanded', String(this.isExpanded))
		}
	}
}
